import { takeLatest, call, put } from "redux-saga/effects";
import {
  PARTNER_QUEUE_ADD_REQUEST,
  partnerQueueAdded,
  partnerQueueAddError,
} from "../../actions/partners";
import addQueue from "../../../../../backend/oncall/administration/partners/queues/add";

const requestAddQueue = function*(action) {
  try {
    yield call(addQueue, action.payload.partnerId, action.payload.queue);
    yield put(partnerQueueAdded(action.payload.queue));
  } catch (error) {
    yield put(partnerQueueAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_QUEUE_ADD_REQUEST, requestAddQueue);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-add-queue.js